import { keyBy } from 'lodash';
import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import User from '@/shared/models/User';
import WorkPreparationStatus from '../constants/WorkPreparationStatus';
import WorkPreparationData from '../models/WorkPreparationData';
import WorkPreparationItem from '../models/WorkPreparationItem';
import WorkPreparationReason from '../models/WorkPreparationReason';

const SCHEMA = {
  id: 'id',
  status: (data: any) => (data.isPreparationApproved ? WorkPreparationStatus.PASSED : WorkPreparationStatus.NOT_OK),
  comment: 'comment',
  reasonId: 'reasonId',
  modifiedOn: (data: any) => parseMoment(data.modifiedOn),
  roleId: 'workPreparationRoleId',
  modifiedBy: (data: any) => User.withFullNameAndAvatar(data.modifiedByName, data.modifiedByAvatar),
};

const REASON_SCHEMA = {
  id: 'id',
  description: 'description',
};

export function parseWorkPreparationItem(data: any): WorkPreparationItem | null {
  return parseEntity(data, SCHEMA, WorkPreparationItem);
}

export function parseWorkPreparationItems(data: any, roles = data.workPreparationRoles, roleId = data.workPreparationRoleId): Array<WorkPreparationItem> {
  const itemDataByRole = keyBy(data.workPreparations ?? data, 'workPreparationRoleId');
  return roles.map((roleData: any) => {
    const itemData = itemDataByRole[roleData.id];
    const result = parseWorkPreparationItem(itemData) ?? new WorkPreparationItem();
    result.title = roleData.description;
    result.editable = roleId === roleData.id;
    return result;
  });
}

export function formatWorkPreparationItem(data: WorkPreparationData): object {
  return {
    status: data.status,
    comment: data.comment || null,
    reasonId: data.reason?.id ?? null,
  };
}

export function parseWorkPreparationReasons(data: any): Array<WorkPreparationReason> {
  return parseEntities(data, REASON_SCHEMA, WorkPreparationReason);
}
